var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.742 2a1.833 1.833 0 0 0-.597.105 1.772 1.772 0 0 0-1.04 1.04c-.066.18-.105.55-.105.55v16.606s.04.375.105.554c.172.465.54.844.997 1.024.191.074.39.113.593.121C8.98 21.992 18 22 18 22c1.105 0 2-.895 2-2V8l-6-6H5.742zM6 4h6v6h6v10H6V4zm8 .828L17.172 8H14V4.828zM8 12v2h2.027v-2H8zm3 0v2h5v-2h-5zm-3 4v2h2.027v-2H8zm3 0v2h5v-2h-5z",
    id: "note-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#note-a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.7bf4422cee75dd0576a809cbaf007f55.svg";
export { ForwardRef as ReactComponent };